import { getPrivileges } from "utils/generalUtils";
import { decryptStorage } from "utils/utils";
import { reviewMyself, insuanceMyself } from "config/configRoutes";

export const ProtectedMySelf = ({
    dashBoardReview,
    dashBoardIssuance
}) => {
    const permisions = JSON.parse(decryptStorage(localStorage.getItem("dataUser")));
    if (getPrivileges(permisions.role, reviewMyself)) {
        return dashBoardReview;
    } else if (getPrivileges(permisions.role, insuanceMyself)) {
        return dashBoardIssuance;
    }else {
        return dashBoardReview;
    }

};